<div class="addContainer">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          <h4> EVENTO DE TOMA DE MEDICACION</h4>
          MEDICAMENTO: <br>
          {{ data.medicamentoNombre }} <br>
        </div>
      </div>
    </div>
    <button (click)="cancel()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>

    <div class="row">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>INDIQUE LAS REACCIONES CAUSADAS POR LA TOMA DEL MEDICAMENTO:</mat-label>
            <textarea
              [(ngModel)]="obs"
              appUppercaseNoAccent
              aria-autocomplete="none"
              autocomplete="nope"
              matInput
            ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row">
            <button (click)="save()" color="primary" mat-flat-button>GUARDAR</button>
            <button (click)="cancel()" color="warn" mat-flat-button tabindex="-1">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
